import { render, staticRenderFns } from "./StaffNavigation.vue?vue&type=template&id=ae932ed8"
import script from "./StaffNavigation.vue?vue&type=script&lang=js"
export * from "./StaffNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports